import { gql } from '@apollo/client'

export const ParagraphRevisionFragment = gql`
    fragment paragraphRevisionFragment on ParagraphRevision {
        text
        numbering
        logType
        message
        children {
            logType
            message
            text
        }
    }
`

export const FileInfoFragment = gql`
    fragment fileInfoFragment on ImportProjectProductFamilyFileExtractionInfo {
        firmId
        projectId
        status
        fileInfo {
            fileKey
            isMasterSpecSection
            title
            parentAssemblyTreePaths
            productTypeCount
            productTypeInfo {
                name
                propertiesCount
                textType
            }
            propertiesCount
            errors
            warnings
            familyId
            backConvertedDiffDocxUri
            paragraphErrors {
                ...paragraphRevisionFragment
            }
            paragraphWarnings {
                ...paragraphRevisionFragment
            }
        }
        errorMessage
        instanceId
    }
    ${ParagraphRevisionFragment}
`
